import type { AccordionEntry, ComparisonColumn, FaqEntry, Testimonial } from "../types/aquagym";

export const CHECKOUT_URL = "CHECKOUT_URL_PENDIENTE_REEMPLAZAR";
export const PRODUCT_IMAGE_URL = "https://cdn.magicpatterns.com/uploads/qnhpYikMSLSh2d6NpEAC33/AQUAGYM_RESUELTA_SF.png";

export const heroBenefits = ["PDF digital", "Acceso inmediato", "Todos los niveles", "Garantía 7 días"];

export const heroProof = [
  "+300 profes confían",
  "7 Tomos + 5 Bonos",
  "4.9/5 valoración",
  "Todo el país · envío digital",
];

export const heroTestimonials: Testimonial[] = [
  {
    quote: "Organicé todo mi año de aquagym en una tarde. Tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico.",
    name: "Valeria M.",
    location: "Buenos Aires",
    role: "INSTRUCTORA DE AQUAGYM EN NATATORIO",
  },
  {
    quote: "Las progresiones por nivel cambiaron todo. Mis alumnas avanzaron más en 2 meses que en todo el año anterior. Y dejaron de abandonar.",
    name: "Carolina R.",
    location: "Rosario",
    role: "PROFE DE AQUAGYM EN GIMNASIO CON PILETA",
  },
  {
    quote: "Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo mezclado.",
    name: "Sofía F.",
    location: "Córdoba",
    role: "INSTRUCTORA DE AQUAGYM GRUPAL E INDIVIDUAL",
  },
];

export const salesTestimonials: Testimonial[] = [
  {
    quote: "Las Fichas de Seguimiento del Bono 2 eliminaron mi inseguridad al evaluar a mis alumnas. Ahora sé exactamente en qué están y qué necesitan. Mis clases tienen otro nivel de profesionalismo.",
    name: "Luciana P.",
    location: "Tucumán",
    role: "PROFE PARTICULAR Y EN NATATORIO",
  },
  {
    quote: "La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión. Las alumnas ahora quieren venir porque siempre hay algo nuevo.",
    name: "Marcela G.",
    location: "Mendoza",
    role: "INSTRUCTORA DE AQUAGYM ONLINE Y PRESENCIAL",
  },
  {
    quote: "El Tomo 6 de gestión me salvó de seguir cobrando lo mismo de siempre. Ahora tengo un sistema profesional visible que me permite justificar mis tarifas. Mi natatorio me reconoce como la instructora más organizada.",
    name: "Laura V.",
    location: "Santa Fe",
    role: "INSTRUCTORA EN NATATORIO Y PILETA MUNICIPAL",
  },
];

export const problems = [
  "Llegás a la clase sin saber exactamente qué ejercicio vas a dar hoy.",
  "Tus alumnas no progresan porque no tenés una secuencia clara de nivel a nivel.",
  "El 40% de tus alumnas abandona antes de los 3 meses y no sabés cómo prevenirlo.",
  "Siempre los mismos ejercicios de siempre porque no tenés más material listo.",
  "No podés justificar un aumento de precio porque no tenés un sistema profesional visible.",
  "Correcciones técnicas improvisadas en el agua, sin un método claro que te respalde.",
  "Alumnas de distintos niveles juntas y la clase se convierte en un caos.",
  "Fin de mes y las alumnas se van sin avisar porque no ven progresión en sus clases.",
];

export const levels = [
  "Principiante",
  "Intermedio",
  "Avanzado",
  "Adultos Mayores",
  "Planificación",
  "Natatorio y Gimnasio",
];

export const includedAreas = [
  "Fundamentos",
  "Nivel Inicial",
  "Nivel Intermedio",
  "Nivel Avanzado",
  "Adultos Mayores",
  "Coreografías",
  "Gestión",
  "Planificación",
  "Técnicas",
  "Corrección",
  "Seguridad",
  "Evaluación",
  "Progresión",
  "Seguimiento",
  "Música",
  "Equipamiento",
];

export const volumes: AccordionEntry[] = [
  {
    id: "tomo-1",
    kicker: "TOMO 1",
    title: "FUNDAMENTOS DEL AQUAGYM",
    quote: "La base que todo instructor necesita dominar antes de entrar al agua",
    items: [
      "Principios del medio acuático: resistencia, flotación e impacto reducido.",
      "Anatomía aplicada al agua: qué músculos trabajan diferente y por qué.",
      "Postura, seguridad e higiene en el medio acuático.",
      "Equipamiento esencial: tablas, mancuernas, cinturones, noodles y más.",
      "Cómo organizar una sesión completa: calentamiento, cuerpo principal y vuelta a la calma.",
      "Errores más frecuentes del instructor principiante.",
      "Aquagym en natatorio vs. gimnasio con pileta: diferencias clave.",
      "Glosario técnico básico para hablar con criterio profesional.",
    ],
  },
  {
    id: "tomo-2",
    kicker: "TOMO 2",
    title: "PLANIFICACIÓN DE CLASES NIVEL INICIAL",
    quote: "Clases completas listas para alumnas que recién empiezan",
    items: [
      "12 clases completas para nivel inicial con objetivo, desarrollo y cierre.",
      "Progresión de 4 semanas: avance gradual semana a semana.",
      "Más de 30 ejercicios descriptos con indicaciones técnicas listas para usar en clase.",
      "Tiempos, series y repeticiones por ejercicio listos para copiar.",
      "Variaciones de dificultad para adaptar en el momento.",
      "Checklist pre y durante la clase.",
      "Indicaciones para el instructor: qué decir, cómo motivar y cómo corregir.",
      "100% adaptado a la realidad del instructor argentino.",
    ],
  },
  {
    id: "tomo-3",
    kicker: "TOMO 3",
    title: "PLANIFICACIÓN DE CLASES NIVEL INTERMEDIO",
    quote: "Para alumnas con base que buscan más intensidad y variedad",
    items: [
      "12 clases completas para nivel intermedio con mayor carga e intensidad.",
      "Circuitos acuáticos: formato estación por estación listo para usar.",
      "Combinaciones de ejercicios: trabajo funcional en el agua.",
      "Control de intensidad sin pulsómetro: técnicas simples y efectivas.",
      "Variantes de dificultad para adaptar en el momento.",
      "Progresión de nivel a nivel: cómo llevar a una alumna de inicial a intermedio.",
      "Planillas de seguimiento del alumno incluidas.",
      "Checklist pre y durante la clase.",
    ],
  },
  {
    id: "tomo-4",
    kicker: "TOMO 4",
    title: "AQUAGYM PARA ADULTOS MAYORES",
    quote: "El nicho más rentable y de mayor crecimiento del acuático",
    items: [
      "Adaptaciones fisiológicas clave: qué cambia después de los 60 y cómo impacta en la clase.",
      "10 clases completas adaptadas con ritmo, impacto y duración ajustados.",
      "Ejercicios de movilidad acuática: cadera, columna y hombros.",
      "Manejo de patologías comunes: artrosis, hipertensión y osteoporosis.",
      "Cómo comunicarse con el grupo mayor: lenguaje, paciencia y motivación.",
      "Indicaciones de seguridad específicas para esta población.",
      "Progresión de 4 semanas adaptada al ritmo del adulto mayor.",
      "Fichas de seguimiento e historial del alumno.",
    ],
  },
  {
    id: "tomo-5",
    kicker: "TOMO 5",
    title: "AQUAGYM CON MÚSICA Y COREOGRAFÍA",
    quote: "Clases que la gente no quiere perderse",
    items: [
      "Cómo estructurar una clase con música: BPM por fase de clase.",
      "8 coreografías base listas para usar, descriptas paso a paso por escrito.",
      "Géneros musicales recomendados: cumbia, reguetón, pop y electro.",
      "Playlists sugeridas por nivel y objetivo, con criterio técnico.",
      "Cómo crear tus propias coreografías: método simple de 5 pasos.",
      "Cómo combinar música e intensidad sin perder el objetivo de la clase.",
      "Recursos para encontrar y organizar tu música como instructor profesional.",
      "Tips para mantener el ritmo del grupo aun con alumnas en distintos niveles.",
    ],
  },
  {
    id: "tomo-6",
    kicker: "TOMO 6",
    title: "GESTIÓN Y NEGOCIO DEL INSTRUCTOR ACUÁTICO",
    quote: "De dar clases a tener un negocio acuático profesional",
    items: [
      "Cómo armar tu propio programa mensual con plantillas editables incluidas.",
      "Técnicas de fidelización de alumnas: cómo hacer que vuelvan siempre.",
      "Cómo cobrar lo que vale tu trabajo: estrategia de precios para instructores.",
      "Redes sociales para instructores de aquagym: qué publicar para atraer alumnas.",
      "Registro y seguimiento de progreso: fichas de alumna incluidas y listas para usar.",
      "Cómo presentarte como profesional ante natatorios y gimnasios.",
      "Cómo vender tus servicios sin sentirte incómoda o incómodo hablando de dinero.",
      "Sistema de referidos: cómo hacer que tus alumnas te recomienden solas.",
    ],
  },
  {
    id: "tomo-7",
    kicker: "TOMO 7",
    title: "AQUAGYM AVANZADO Y PROGRESIONES",
    quote: "Clases avanzadas para alumnas que buscan más desafío, intensidad y evolución",
    items: [
      "12 clases completas para nivel avanzado.",
      "Progresiones de intensidad y dificultad.",
      "Ejercicios complejos de fuerza, resistencia, coordinación y potencia.",
      "Combinaciones avanzadas listas para utilizar.",
      "Adaptaciones para alumnas con mayor experiencia.",
      "Cómo aumentar la dificultad sin perder seguridad ni técnica.",
      "Estrategias para evitar el estancamiento y el aburrimiento.",
      "Evaluación del progreso y criterios para avanzar de nivel.",
      "Variaciones para grupos avanzados y grupos con niveles mixtos.",
      "Clases listas para usar en natatorios y gimnasios con pileta.",
    ],
  },
];

export const everyVolumeIncludes = [
  "Planificación lista para usar desde el primer día.",
  "Clases con objetivo, desarrollo y cierre.",
  "Indicaciones técnicas listas para usar en clase.",
  "Variaciones Nivel 1, Nivel 2 y Nivel 3 por ejercicio.",
  "Checklist pre y durante la clase.",
  "Planillas de seguimiento del alumno.",
  "Adaptaciones para grupos heterogéneos.",
  "100% adaptado a la realidad del instructor de aquagym argentino.",
];

export const bonuses: AccordionEntry[] = [
  {
    id: "bono-1",
    kicker: "BONO 1",
    title: "BANCO DE EJERCICIOS ACUÁTICOS ILUSTRADO",
    value: "Valor de referencia: $12.000 → GRATIS",
    items: [
      "Más de 100 ejercicios categorizados por objetivo y zona de trabajo.",
      "Descripción clara de posición inicial, ejecución y finalización.",
      "Objetivo específico de cada ejercicio: para qué sirve y cuándo usarlo.",
      "Variantes por nivel de dificultad, con y sin material.",
      "Formato visual e imprimible para tener al borde de la pileta.",
      "Organizado por zona de trabajo, objetivo y nivel.",
      "Ejercicios con noodle, tabla, mancuernas y sin material.",
    ],
  },
  {
    id: "bono-2",
    kicker: "BONO 2",
    title: "PLANILLAS DE SEGUIMIENTO DEL ALUMNO",
    value: "Valor de referencia: $10.000 → GRATIS",
    items: [
      "Ficha de evaluación inicial del alumno lista para imprimir o completar digitalmente.",
      "Registro de asistencia semanal y mensual.",
      "Seguimiento de progreso por nivel y objetivo.",
      "Historial de clase por alumno.",
      "Ficha de objetivos personales del alumno.",
      "Hoja de alta médica simplificada para instructores.",
      "Formato editable para personalizar con tu marca.",
    ],
  },
  {
    id: "bono-3",
    kicker: "BONO 3",
    title: "AQUAGYM PARA EMBARAZADAS",
    value: "Valor de referencia: $9.000 → GRATIS",
    items: [
      "Beneficios del aquagym durante el embarazo por trimestre.",
      "8 clases completas adaptadas: ritmo, impacto y duración por trimestre.",
      "Ejercicios contraindicados: qué nunca hacer y por qué.",
      "Cómo comunicarse con alumnas embarazadas: lenguaje y contención.",
      "Coordinación con el médico obstetra: cuándo consultar.",
      "Adaptaciones posturales específicas para cada etapa del embarazo.",
      "Ficha de derivación al profesional de salud incluida.",
    ],
  },
  {
    id: "bono-4",
    kicker: "BONO 4",
    title: "GUÍA COMPLETA DE EJERCICIOS CON NOODLE",
    value: "Valor de referencia: $10.000 → GRATIS",
    items: [
      "Más de 40 ejercicios exclusivos con noodle descriptos paso a paso.",
      "Ejercicios para tren superior, tren inferior y core con noodle.",
      "Variantes por nivel: cómo hacer el mismo ejercicio más fácil o más difícil.",
      "Combinaciones de noodle con otros materiales.",
      "Cómo usar el noodle para flotación y resistencia en la misma clase.",
      "Formato visual listo para tener al borde de la pileta.",
      "Progresión de 4 semanas usando solo noodle.",
    ],
  },
  {
    id: "bono-5",
    kicker: "BONO 5",
    title: "PLANIFICACIÓN ANUAL DE AQUAGYM LISTA",
    value: "Valor de referencia: $9.000 → GRATIS",
    items: [
      "12 meses de periodización acuática en tablas listas para usar.",
      "Distribución de objetivos por trimestre: base, intensidad y mantenimiento.",
      "Planificación adaptada a la estacionalidad argentina.",
      "Cómo ajustar el plan según asistencia y progreso real del grupo.",
      "Tabla de progresión anual para alumnas de larga trayectoria.",
      "Versión para natatorio con pileta climatizada todo el año.",
      "Versión para espacios con pico estacional durante el verano.",
    ],
  },
];

export const specialPromotions = [
  {
    title: "Aquagym HIIT y Funcional",
    detail: "10 clases HIIT acuáticas, intervalos de trabajo y recuperación, entrenamiento funcional acuático y periodización mensual de la intensidad.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/bc1ad49d-b5c9-4a0a-ba73-748bc261388d.jpg",
  },
  {
    title: "Programa de 90 Días Listo para Entregar",
    detail: "Programa semana a semana, 3 niveles, fichas de progreso, scripts de venta y certificado de finalización.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/1c02e3a8-b36c-43a2-972e-339383922115.jpg",
  },
];

export const purchaseBenefits = ["Pago seguro", "Acceso en menos de 5 minutos", "Garantía 7 días", "Mercado Pago"];

export const faqs: FaqEntry[] = [
  { id: "faq-1", question: "¿Cómo recibo Aquagym Resuelto después de comprar?", answer: "Inmediatamente después de confirmar el pago recibís un email con el enlace de descarga de los PDFs. El acceso llega en menos de 5 minutos y podés abrir el material desde cualquier dispositivo." },
  { id: "faq-2", question: "¿Sirve para instructores con poca experiencia o solo para avanzados?", answer: "Sí. El sistema comienza con fundamentos y nivel inicial, y avanza hacia planificación intermedia, avanzada, adultos mayores, música, coreografía, gestión y entrenamiento HIIT/funcional." },
  { id: "faq-3", question: "¿El material es editable?", answer: "No. Es material digital en formato PDF, preparado para leer, descargar e imprimir. No se puede editar ni modificar, pero podés usarlo como guía de trabajo en tus clases." },
  { id: "faq-4", question: "¿Los 5 bonos están incluidos?", answer: "Sí. La oferta incluye exactamente 5 bonos estratégicos, sin costo adicional." },
  { id: "faq-5", question: "¿Sirve para clases individuales o grupales?", answer: "Sirve para ambas modalidades e incluye adaptaciones para grupos heterogéneos." },
  { id: "faq-6", question: "¿Qué hago si tengo alumnas de distintos niveles al mismo tiempo?", answer: "Las variaciones de Nivel 1, Nivel 2 y Nivel 3 permiten adaptar el mismo ejercicio y mantener organizada la clase." },
  { id: "faq-7", question: "¿Qué diferencia tiene con otros materiales?", answer: "No es una lista aislada de ejercicios: es un sistema estructurado con progresiones, planificación, indicaciones técnicas, seguimiento, seguridad y gestión profesional." },
  { id: "faq-8", question: "¿Tiene garantía real?", answer: "Sí. Contás con 7 días de garantía y devolución del 100% si el material no cumple tus expectativas." },
];

export const comparisons: ComparisonColumn[] = [
  {
    title: "SIN AQUAGYM RESUELTO",
    positive: false,
    items: [
      "3–5 horas por semana planificando desde cero.",
      "Siempre los mismos ejercicios y alumnas aburridas.",
      "Alumnas que abandonan sin saber por qué.",
      "Sin progresión clara de nivel a nivel.",
      "Dificultades técnicas resueltas con improvisación.",
      "Niveles mezclados que generan caos.",
      "Sin sistema de seguimiento.",
      "Sin identidad profesional visible.",
    ],
  },
  {
    title: "CON AQUAGYM RESUELTO",
    positive: true,
    items: [
      "Planificación rápida y clases listas para usar.",
      "60+ clases distintas y variedad real.",
      "Sistema de progresión para mejorar la retención.",
      "7 tomos con fundamentos, niveles, especialidades y gestión.",
      "Protocolos e indicaciones técnicas para actuar con confianza.",
      "Variaciones por nivel para trabajar con grupos mixtos.",
      "Fichas y planillas para registrar con criterio.",
      "Sistema profesional que ayuda a justificar tus tarifas.",
    ],
  },
];
